import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Button, Icon, Popover, RadioGroup } from "@blueprintjs/core";
import {
  calculateTm,
  calculateNebTm,
  calculateSantaLuciaTm
} from "@teselagen/sequence-utils";
import { isNumber, isString } from "lodash-es";
import { popoverOverflowModifiers } from "@teselagen/ui";
import useTmType from "../utils/useTmType";
export default function MeltingTemp({
  sequence,
  WrapperToUse = (p) => /* @__PURE__ */ jsx("div", { children: p.children }),
  InnerWrapper = (p) => /* @__PURE__ */ jsx(Button, { minimal: true, small: true, children: p.children })
}) {
  const [
    primerConc
    /* , setPrimerConcentration */
  ] = React.useState(5e-7);
  const [
    monovalentCationConc
    /* , setMonovalentCationConc */
  ] = React.useState(0.05);
  const [tmType, setTmType] = useTmType();
  let tm = (tmType === "neb_tm" ? calculateNebTm : tmType === "default" ? calculateSantaLuciaTm : calculateTm)(sequence, {
    monovalentCationConc,
    primerConc
  });
  if (isNumber(tm)) {
    tm = tm.toFixed(1);
  }
  const hasWarning = isString(tm) && tm.length > 7 && tm;
  return /* @__PURE__ */ jsx(WrapperToUse, { dataTest: "veStatusBar-selection-tm", children: /* @__PURE__ */ jsx(
    Popover,
    {
      modifiers: popoverOverflowModifiers,
      content: /* @__PURE__ */ jsxs("div", { style: { maxWidth: 300, padding: 20 }, children: [
        "Using Tm calculations based on these",
        " ",
        /* @__PURE__ */ jsx(
          "a",
          {
            rel: "noopener noreferrer",
            target: "_blank",
            href: "https://github.com/TeselaGen/tg-oss/blob/master/packages/sequence-utils/src/calculateNebTm.js",
            children: "algorithms"
          }
        ),
        /* @__PURE__ */ jsx("br", {}),
        /* @__PURE__ */ jsx("br", {}),
        /* @__PURE__ */ jsx(
          RadioGroup,
          {
            label: "Choose Tm Type:",
            options: [
              { value: "default", label: "Santa Lucia (Default)" },
              { value: "breslauer", label: "Breslauer" },
              { value: "neb_tm", label: "NEB Tm" }
            ],
            onChange: (e) => setTmType(e.target.value),
            selectedValue: tmType
          }
        ),
        hasWarning && /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              style: { marginLeft: 5, marginRight: 5 },
              size: 10,
              icon: "warning-sign"
            }
          ),
          hasWarning,
          /* @__PURE__ */ jsx("br", {}),
          /* @__PURE__ */ jsx("br", {}),
          "Try using the Default Tm"
        ] })
      ] }),
      children: /* @__PURE__ */ jsxs(React.Fragment, { children: [
        /* @__PURE__ */ jsxs(InnerWrapper, { children: [
          "Melting Temp: ",
          Number(tm) || 0,
          "\xB0C"
        ] }),
        hasWarning && /* @__PURE__ */ jsx(
          Icon,
          {
            style: { marginLeft: 5, marginRight: 5 },
            size: 10,
            icon: "warning-sign"
          }
        )
      ] })
    }
  ) });
}
